import { useNavigate } from "react-router-dom";
import React, { useRef, useState, useEffect } from "react";
import cr from "../assets/CR.png";
import b2 from "../assets/B2.png";
import img4 from "../assets/IMG4.svg";
import img5 from "../assets/IMG5.svg";
import img6 from "../assets/IMG6.svg";
import k1 from "../assets/K1.svg";
import k2 from "../assets/K2.svg";
import k3 from "../assets/K3.svg";
import k4 from "../assets/K4.svg";
import k5 from "../assets/K5.svg";
import k6 from "../assets/K6.svg";


const SAGate = () => {


  const features = [
    {
      img: img4,
      title: 'Access control',
      desc: 'Feature that helps manage who can enter a facility, when, and where they can go.',
    },
    {
      img: img5,
      title: 'Security upgrade',
      desc: 'Enhancing the system’s ability to prevent unauthorized access, monitor visitor activity.',
    },
    {
      img: img6,
      title: 'Operation efficiency',
      desc: 'Helps streamline processes, reduce manual work, and improve the overall speed and accuracy.',
    },
  ];




  return (
    <div>
         <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: "50px 40px",
        background: "linear-gradient(135deg, #2C8C53, #11552D)",
        color: "white",
        fontFamily: "Epilogue, sans-serif",
      }}
    >
      {/* Left Content */}
      <div
        style={{
          flex: "1 1 45%",
          minWidth: "300px",
          paddingRight: "30px",
        }}
      >
        <h1
          style={{
            fontSize: "50px",
            fontWeight: "500",
            marginBottom: "16px",
          }}
        >
          Get started with a <br /> product demo
        </h1>
        <p style={{ marginBottom: "32px", fontSize: "12px", lineHeight: "1.6" }}>
          Our vision is to revolutionize the way organization manage their visitors.
        </p>

        {[
          "Get an overview of Gate",
          "Learn how to customize the tool for your organization",
          "Discuss pricing plans and scale up when needed",
          "Q&A session with our product expert",
        ].map((text, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "16px",
              fontSize: "16px",
            }}
          >
            <img
  src={cr}
  alt="Check"
  style={{ width: "20px", height: "20px" }}
/>

            <span>{text}</span>
          </div>
        ))}
      </div>

      
      <div
        style={{
          flex: "1 1 30%",
          minWidth: "100px",
          backgroundColor: "#ffffff",
          padding: "20px 24px",
          borderRadius: "20px",
          boxShadow: "0px 4px 16px rgba(0,0,0,0.1)",
          color: "#111827",
        }}
      >
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "700",
            marginBottom: "20px",
            fontFamily:"Epilogue",
            textAlign: "left",
          }}
        >
          Get personalized demo
        </h2>

        <form>
          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "600",
                fontSize: "14px",
                marginBottom: "6px",
              }}
            >
              Name
            </label>
            <input
              type="text"
              style={{
                width: "90%",
                padding: "12px",
                border: "1px solid #D1D5DB",
                borderRadius: "8px",
                fontSize: "14px",
              }}
              placeholder="Your name"
            />
          </div>

          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "600",
                fontSize: "14px",
                marginBottom: "6px",
              }}
            >
              Mobile Number
            </label>
            <input
              type="tel"
              defaultValue="+91"
              style={{
                width: "90%",
                padding: "12px",
                border: "1px solid #D1D5DB",
                borderRadius: "8px",
                fontSize: "14px",
              }}
            />
          </div>

          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "600",
                fontSize: "14px",
                marginBottom: "6px",
              }}
            >
              Email
            </label>
            <input
              type="email"
              style={{
                width: "90%",
                padding: "12px",
                border: "1px solid #D1D5DB",
                borderRadius: "8px",
                fontSize: "14px",
              }}
              placeholder="Your email"
            />
          </div>

          <p style={{ fontSize: "12px", color: "#4B5563", marginBottom: "16px" }}>
            By submitting this form, you agree to the processing of personal data
            according to our{" "}
            <a href="#" style={{ color: "#1D4ED8", textDecoration: "underline" }}>
              Privacy Policy
            </a>
            .
          </p>

          <button
            type="submit"
            style={{
              width: "100%",
              backgroundColor: "#1F8A4C",
              color: "#fff",
              padding: "14px",
              fontSize: "16px",
              fontWeight: "bold",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>


    <div style={{ fontFamily: "Epilogue", fontSize: "40px", fontWeight: "500", marginTop: "50px", textAlign: "center" }}>
  Optimizing security and efficiency
</div>

<div style={{ fontFamily: "Epilogue", fontSize: "14px", fontWeight: "400", marginTop: "20px", textAlign: "center", lineHeight: "1.4", padding: "0 10px" }}>
  Our smart gate management system enhances operational flow by streamlining access control, reducing bottlenecks, <br />
  and ensuring secure, efficient movement across your facility.
</div>

<div
  style={{
    marginTop: "40px",
    backgroundColor: '#E7FAEC',
    padding: '20px',
    fontFamily: 'Epilogue',
    display: 'flex',
    flexWrap: 'wrap',
    borderRadius: '20px',
    justifyContent: 'center',
    gap: '30px',
    width: '90%', // responsive width
    maxWidth: '1000px',
    height: "auto", // allow height to grow with content
    marginLeft: 'auto',
    marginRight: 'auto',
    boxSizing: 'border-box',
  }}
>
  {features.map((item, i) => (
    <div
      key={i}
      style={{
        width: '280px', // slightly reduced for tighter screens
        textAlign: 'center',
        flex: "1 1 280px", // allows flexible wrapping
      }}
    >
      <img
        src={item.img}
        alt={item.title}
        style={{ width: '100%', height: 'auto', marginBottom: '20px', textAlign: "left" }}
      />
      <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#111827', marginBottom: '10px', textAlign: "left" }}>
        {item.title}
      </h3>
      <p style={{ fontSize: '12px', color: '#374151', lineHeight: 1.5, textAlign: "left" }}>{item.desc}</p>
    </div>
  ))}
</div>


<div style={{ fontFamily: "Epilogue", fontSize: "40px", fontWeight: "600", marginTop: "50px", textAlign: "center",lineHeight:"1.3" }}>
Digital Gate pass systems  <br/>in various industries
</div>
<div style={{ fontFamily: "Epilogue", fontSize: "14px", fontWeight: "400", marginTop: "20px", textAlign: "center", lineHeight: "1.3" }}>
Digital gate pass systems are transforming various industries by modernizing how people, vehicles, <br/>
and goods are tracked and managed at entry and exit points.
</div>
<div style={{ background: "#f9f9f9", padding: "60px 20px", fontFamily: "Epilogue, sans-serif", textAlign: "center" ,marginTop:"40px"}}>
  <h2 style={{ fontSize: "30px", fontWeight: "400", marginBottom: "10px", color: "#1a1a1a" }}>
    Know our app expertise
  </h2>
  <p style={{ fontSize: "14px", color: "#555", marginBottom: "40px",fontWeight:"300" }}>
    Explore how our app enhances your organization's visitor management
  </p>
  <div style={{
  display: "flex",
  flexWrap: "wrap", // allow wrapping
  justifyContent: "center",
  gap: "20px",
  padding: "10px",
  maxWidth: "2200px", // adjust for layout container
  margin: "0 auto",
}}>
  {[
    "Tracks visitor entry, exit, and purpose",
    "Tracks vehicles entry, exit, and purpose",
    "Tracks couriers entry and exit",
    "Streamlines check-in/check-out process",
  ].map((text, i) => (
    <div key={i} style={{
      display: "flex",
      alignItems: "center",
      backgroundColor: "#fff",
      borderRadius: "999px",
      padding: "10px 20px",
      width:"230px",
      fontSize: "11.1px",
      color: "#222",
      whiteSpace: "nowrap",
    }}>
      <span style={{ color: "green", fontSize: "14px", marginRight: "10px" }}>✔</span>
      {text}
    </div>
  ))}
  
</div>
<div style={{
  backgroundColor: "#fff",
  padding: "30px 30px",
  fontFamily: "Epilogue, sans-serif",
  borderRadius: "30px",
  maxWidth: "1200px",
  margin: "30px auto"
}}>
  <div style={{
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "30px",
    justifyContent: "center",
  }}>
    {[
      { title: "Tech & Corporate Offices", img:k1 },
      { title: "Hospitality", img:k2 },
      { title: "Educational Institutions", img: k3},
      { title: "Manufacturing", img:k4},
      { title: "Warehouse", img:k5 },
      { title: "Logistics", img: k6 },
    ].map((item, i) => (
      <div key={i} style={{
        backgroundColor: "#EEFFF5",
        borderRadius: "24px",
        padding: "20px 20px",
        textAlign: "center",
        boxShadow: "0 4px 10px rgba(0,0,0,0.03)"
      }}>
        <img
          src={item.img}
          alt={item.title}
          style={{ width: "40px", height: "40px", marginBottom: "20px" }}
        />
        <div style={{ fontSize: "16px", fontWeight: 500, color: "#1a1a1a" }}>
          {item.title}
        </div>
      </div>
    ))}
  </div>
</div>



</div>

    </div>
  )
}

export default SAGate